import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

const RouterLink = forwardRef(({ href, ...other }, ref) => <Link ref={ref} to={href} {...other} />);

export default RouterLink;
